import { Breadcrumb, Layout, Image, Row, Col, message, Card, Upload, ConfigProvider, Input, Tabs, Typography, Checkbox } from 'antd';
import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import { EditOutlined, RollbackOutlined, PlusOutlined, ArrowRightOutlined } from '@ant-design/icons';
import LessonModal from './LessonModal';
import Label_language from '../../language';
import Carousel_news_ticker from './Carousel_news_ticker';
const { Title, Paragraph, Text, Link } = Typography;
const label_language = Label_language.cramschool.children
const LessonCotent = () => {
    const { Id } = useParams();
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const [permission, setPermission] = useState(false);
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();
    const [title, setTitle] = useState(label_language.Common.children.add[language]);
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [lesson_open, setLessonOpen] = useState(false);
    const [lessonData, setLessonData] = useState([]);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    useEffect(() => {
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                if (response.data.length != 0) {
                    setPermission(true);
                }
            })
        get_data();
    }, [])
    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/lesson_category', { params: { "blog_type_id": 5, blog_id: Id } })
            .then((response) => {
                setLessonData(response.data.data[0].lesson_data);
                getLesson_Pic(response.data.data[0].lesson_data);

            })
    }
    const getLesson_Pic = (data_tmp) => {
        data_tmp && data_tmp.map((value, index) => {
            let lesson_id = value['lesson_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setLessonData(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (lesson_id == value.lesson_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    const handleLessonEdit = (file_id) => {
        // console.log(file_id, editcard);
        axios
            .patch('/cramSchool/api/lesson', [{ ...editcard, file_id: file_id }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setLessonOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });

                } else {
                    setLessonOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
            })
            .finally(() => {
                get_data();
            })
    }
    const handleOnLessonEdit = (value) => {
        // console.log(value);
        setTitle(label_language.Lesson.children.edit_lesson[language]);
        setEdit(true);
        setEditCard(value);
        setColor('f09a45');
        setLessonOpen(true);
        // axios
        //     .patch('cramSchool/api/lesson', [])
    }
    // useEffect(() => {
    //     console.log(lessonData)
    // }, [lessonData])
    return (
        <>
            {contextHolder}
            <LessonModal
                open={lesson_open}
                setOpen={setLessonOpen}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                edit={edit}
                title={title}
                handleEdit={handleLessonEdit}
            />
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <RollbackOutlined style={{ fontSize: '30px' }} onClick={e => navigate(-1)} />
                </Col>
                <Col span={24}>
                    <Row justify={'center'} gutter={[40, 8]}>
                        {lessonData && lessonData.map((value, index) => {
                            return (
                                <>
                                    < Col sm={{ span: 24 }
                                    } md={{ span: 8 }} justify='center' style={{ position: 'relative', minWidth: dimensions['width'] < 500 ? '100%' : 'auto' }}>
                                        <Card
                                            hoverable
                                            bodyStyle={{
                                                minHeight: '15rem',
                                                maxHeight: '15rem',
                                                position: 'relative',
                                            }}

                                            cover={(
                                                <>
                                                    {permission ? <>
                                                        <Row style={{ position: 'relative', justifyContent: 'end', }}>
                                                            <Col className='example' style={{ position: 'absolute', left: '90%', top: '0%', zIndex: 99 }}>
                                                                <EditOutlined
                                                                    className='example'
                                                                    style={{
                                                                        backgroundColor: '#F9D4E5',
                                                                        fontSize: '1.2rem',
                                                                        borderRadius: '50%',
                                                                        padding: '8px'
                                                                    }}
                                                                    onClick={e => handleOnLessonEdit(value)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </>
                                                        : null}
                                                    <Carousel_news_ticker
                                                        style={{ position: 'relative' }}
                                                        file_url={value['file_url']}
                                                        url={`/cramSchool/ClassIntroduce/${Id}/${value.lesson_id}`}
                                                        backgroundColor={value.pic_background_color || '#FFFFFF'}
                                                    />
                                                </>)
                                            }
                                            style={{ backgroundColor: value.background_color || '#ffef9882' }}
                                        >
                                            <Row justify={'end'} gutter={[16, 16]} onClick={e => navigate(`/cramSchool/ClassIntroduce/${Id}/${value.lesson_id}`)}>
                                                <Col span={24} style={{ fontSize: '1.5rem', color: value.font_color || 'black' }}>{value['name']}</Col>
                                                <Col span={24} >
                                                    <Paragraph
                                                        style={{ color: value.font_color || 'black' }}
                                                        ellipsis={{
                                                            rows: 3,
                                                            expandable: true,
                                                            symbol: 'more',
                                                        }}
                                                    >
                                                        {value['outline']}
                                                    </Paragraph>
                                                </Col>
                                                <Col style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
                                                    <Col>
                                                    </Col>
                                                    <Col className='example'>
                                                        <span style={{ textDecoration: 'underline', cursor: 'pointer', color: value.font_color || 'black' }} onClick={e => navigate(`/cramSchool/ClassIntroduce/${Id}/${value.lesson_id}`)}>{label_language.Common.children.learn_more[language] && '了解更多'}</span>
                                                        <ArrowRightOutlined style={{ color: value.font_color || 'black' }} onClick={(e) => navigate(`/cramSchool/ClassIntroduce/${Id}/${value.lesson_id}`)} />
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card >
                                    </Col >
                                </>
                            )

                        })}
                    </Row>
                </Col>
            </Row>
        </>
    )
}
export default LessonCotent;